import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { useUserStoreWithOut } from '@/store/modules/user'
import { getCurrentUserApi } from '@/api/common'
import { getOnlyMenuTreeApi } from '@/api/menu'
import { transformMenu, getFirstMenuFullPath } from '@/utils/formatMenu'
import { listToTree } from '@/utils/tree'
const { start, done } = useNProgress()
const { loadStart, loadDone } = usePageLoading()
router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore: any = useUserStoreWithOut()
  // debugger
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (to.query.access) {
        await getRole(to)
        next()
        return
      }
      if (to.query.username) {
        if (userStore.getUserInfo.userName != to.query.username) {
          await getRole(to)
          next()
          return
        }
      }
      if (permissionStore.getIsAddRouters) {
        permissionStore.getAddRouters.forEach((route) => {
          const routeName = (route as RouteRecordRaw).name
          if (!routeName || !router.hasRoute(routeName)) {
            router.addRoute(route as unknown as RouteRecordRaw)
          }
        })
        const routers: any = userStore.getRoleRouters
        const firstRoute = getFirstMenuFullPath(routers)
        if (
          (to.path === '/' || (to.path === '/404' && to.redirectedFrom?.path === '/')) &&
          firstRoute
        ) {
          next({ path: firstRoute, replace: true })
          return
        }
        next()
        return
      }

      // 开发者可根据实际情况进行修改
      const roleRouters = userStore.getRoleRouters || []
      // 是否使用动态路由
      if (appStore.getDynamicRouter) {
        appStore.serverDynamicRouter
          ? await permissionStore.generateRoutes('server', roleRouters as AppCustomRouteRecordRaw[])
          : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      permissionStore.setIsAddRouters(true)

      const routers: any = userStore.getRoleRouters
      const firstRoute = getFirstMenuFullPath(routers)

      // 首次进入根路径或命中404时，如果已经生成了路由，直接引导至第一个菜单
      if (
        (to.path === '/' || (to.path === '/404' && to.redirectedFrom?.path === '/')) &&
        firstRoute
      ) {
        next({ path: firstRoute, replace: true })
        return
      }

      const redirectPath = (to.query.redirect as string) || from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData =
        to.path === redirect ? { ...to, replace: true } : { path: redirect, replace: true }
      next(nextData)
      // const routers: any = userStore.getRoleRouters
      // const firstRoute = getFirstMenuFullPath(routers)
      // const redirectPath = from.query.redirect || firstRoute?.path
      // const redirect = decodeURIComponent(redirectPath as string)
      // // const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      // const nextData = to.path === redirect ? { ...to, replace: true } : { path: firstRoute }
      // permissionStore.setIsAddRouters(true)
      // next(nextData)
    }
  } else {
    if (to.query.access) {
      await getRole(to)
      next()
      return
    }
    if (to.query.username) {
      if (!userStore.getUserInfo?.userName || userStore.getUserInfo.userName != to.query.username) {
        await getRole(to)
        next()
        return
      }
    } else {
      // window.open(`${appStore.redirectUrl}?redirectUrl=${window.location.href}`, '_self')
      const redirectUrl = encodeURIComponent(window.location.href)
      console.log(`${appStore.redirectUrl}?flag=oms&redirect=${redirectUrl}`)
      window.open(`${appStore.redirectUrl}?flag=oms&redirect=${redirectUrl}`, '_self')
      // window.open(`${appStore.redirectUrl}?redirectUrl=${window.location.href}`, '_blank')
    }
  }
})

// // 获取角色信息
const getRole = async (to) => {
  const permissionStore = usePermissionStoreWithOut()
  const userStore = useUserStoreWithOut()
  let token: any = null
  if (to.query?.access) {
    token = to.query.access
  }
  // debugger
  //获取url参数中的token
  userStore.setToken(token)
  const userInfo = await getCurrentUserApi()
  const user = userInfo.data.user
  userStore.setLoginInfo({
    username: user.username,
    password: ''
  })
  userStore.setUserInfo({
    username: user.username,
    password: '',
    ...user
  })

  // const { addRoute, replace } = useRouter()
  // const res = await getOnlyMenuTreeApi({ appId: 2 })
  const res = await getOnlyMenuTreeApi({ appId: 2 })
  // if (res.data.length == 0) {
  //   // const appStore = useAppStoreWithOut()
  //   // window.open(`${appStore.redirectUrl}?redirectUrl=${window.location.href}`, '_self')
  //   // window.open(`${appStore.redirectUrl}?redirectUrl=${window.location.href}`, '_blank')
  //   alert('没权限')
  //   window.close()
  //   return
  // }

  const routers = transformMenu(listToTree(res.data))
  userStore.setRoleRouters(routers)
  await permissionStore.generateRoutes('server', routers).catch(() => {})
  permissionStore.getAddRouters.forEach((route) => {
    router.addRoute(route as RouteRecordRaw) // 动态添加可访问路由表
  })
  permissionStore.setIsAddRouters(true)
  const firstRoute = getFirstMenuFullPath(routers)
  if (firstRoute) {
    router.replace({ path: firstRoute })
  }
}

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
